import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '@env/environment';
import { ApiUtils } from '@core/services/Utils/apiUtils';
import { get } from '@core/interceptors/fetch-client';
import { ParticipationGridResponseData } from '@interface/participation';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ParticipationService implements OnDestroy {
  private destroy$ = new Subject<void>();
  private gridParticipationSubject =
    new BehaviorSubject<ParticipationGridResponseData | null>(null);
  readonly gridParticipation$ = this.gridParticipationSubject.asObservable();

  constructor() {}

  public async fetchParticipationGridData(data: any): Promise<any> {
    let response = null;
    try {
      const isLocalhost = window.location.hostname === 'localhost';
      let url = `${environment.getParticipationData}?Stmt_Month=${data.Stmt_Month}&Group_Code=${data.Group_Code}&Stmt_Year=${data.Stmt_Year}`;
      if (isLocalhost) {
        url += `&code=${environment.functionappCode}`;
      }
      await ApiUtils.handleApiResponse1(
        get<any>(url, {}, true), // <-- Pass `true` for Python Web API
        (data, statusCode) => {
          response = { data, statusCode };
          if (statusCode === 200) {
            this.updateParticipationGridData(data);
          }
        },
        'Failed to fetch Participation data:',
      );
    } catch (error: any) {
      console.error('Failed to fetch Participation Data', error);
      response = { data: error, statusCode: error.status || error.statusCode };
    }
    return response;
  }

  updateParticipationGridData(data: ParticipationGridResponseData) {
    this.gridParticipationSubject.next(data);
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
    this.gridParticipationSubject.unsubscribe();
  }
}
